import * as R from 'ramda';
import { OrderStatus } from '../../../../../../interfaces/order-status.interface';
import { OrderProductGridItem, UpdateItemFormat } from '../../../../../orderProducts.types';
import { SuggestedGridItem } from '../../../../suggestedGrid/suggested-grid.interface';
import { GridItemToValidate } from '../types/productGrid.types';

const validateSuggestionAchieved = (
  grid: OrderProductGridItem[] | GridItemToValidate[],
  suggestedGrid: SuggestedGridItem[],
): boolean => {
  if (grid.length === 0) {
    return false;
  }
  const gridTotalQuantity = grid.reduce(
    (accumulator, gridItem) => accumulator + (gridItem.orderItemQuantity ?? 0),
    0,
  );
  const suggestedGridTotalQuantity = suggestedGrid.reduce(
    (accumulator, suggestedItem) => accumulator + (suggestedItem.orderItemQuantity ?? 0),
    0,
  );
  return gridTotalQuantity >= suggestedGridTotalQuantity;
};

const validateShowSuggestedGrid = (
  suggestedGrid: SuggestedGridItem[],
  orderStatus?: OrderStatus,
): boolean => {
  if (orderStatus === 'SUGGESTED' || suggestedGrid.length === 0) {
    return false;
  }

  return suggestedGrid.some((gridItem) => {
    return !R.isNil(gridItem.orderItemQuantity);
  });
};

interface GetSuggestedGridHandlerProps {
  grid: OrderProductGridItem[];
  suggestedGrid: SuggestedGridItem[];
  createOrderItems?: UpdateItemFormat[];
  orderStatus?: OrderStatus;
}

export const getSuggestedGridHandler = ({
  grid,
  suggestedGrid,
  createOrderItems,
  orderStatus,
}: GetSuggestedGridHandlerProps) => {
  const hasCreateOrderItems = createOrderItems && createOrderItems.length > 0;
  const formattedGrid: GridItemToValidate[] = hasCreateOrderItems
    ? createOrderItems.map((createItem) => ({
        orderItemQuantity: createItem.quantity,
        skuId: createItem.skuId,
      }))
    : grid.map((gridItem) => ({
        orderItemQuantity: gridItem.orderItemQuantity,
        skuId: gridItem.skuId,
      }));

  const suggestionAchieved = validateSuggestionAchieved(formattedGrid, suggestedGrid);
  const showSuggestedGrid = validateShowSuggestedGrid(suggestedGrid, orderStatus);

  return { showSuggestedGrid, suggestionAchieved };
};
